<template>
    <div>
        <Loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="false"></Loading>

        <!-- Page Tittle Start -->
        <section class="page-tittle page-tittle-lg bg dark-overlay bgBanner">
            <div class="container">
                <div class="page-tittle-head display-block text-center">
                    <h2>Orodje</h2>
                </div>
                <ol class="breadcrumb mrg-top-30 display-block text-center">
                    <li class="breadcrumb-item d-inline-block"><a @click="$router.push({name: 'Tools'})">Vsa orodja</a></li>
                    <li class="breadcrumb-item d-inline-block"><a @click="$router.push({name: 'Tools', params: { categoryId: tool.category}})">{{getReadableCategory(tool.category)}}</a></li>
                    <li class="breadcrumb-item d-inline-block active">{{tool.name}}</li>
                </ol>
            </div>
        </section>
        <!-- Page Tittle End -->


        <!-- Product Single Start -->
        <section class="section-3">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="swiper-container gallery-screen no-pdd">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img class="img-responsive" :src="tool.photo" style="max-width: 100%" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mrg-top-90">
                                    <h2 class="mrg-btm-30 lh-1">{{tool.name}}<div><small class="text-muted font-size-18">@{{getReadableUser(tool.location)}}</small></div></h2>
                                    <p class="width-70 mrg-btm-30">{{tool.description}}</p>

                                    <p class="width-70 mrg-btm-30" v-if="tool.link"><span class="font-weight-bold">Več informacij</span> <br/><a :href="tool.link" target="_blank" >{{tool.link}}</a></p>

                                    <p class="width-70 mrg-btm-30"><span class="font-weight-bold">Opombe</span> <br/>{{tool.notes ? tool.notes : '/'}}</p>

                                    <p class="width-70 mrg-btm-30"><span class="font-weight-bold">Kategorija</span> <br/>{{getReadableCategory(tool.category)}}</p>

                                    <small class="width-70 mrg-btm-30" v-if="tool && tool.updatedAt">Zadnja sprememba: {{moment.unix(tool.updatedAt.seconds).format('DD. MM. YYYY')}}</small>

                                    <div class="mrg-top-50">
                                        <a class="btn btn-md btn-primary text-white" @click="onWhatsappClick(tool)"><i class="fab fa-whatsapp"></i> Piši kontaktni osebi: <b>{{tool.contactPerson}}</b></a>
                                    </div>

                                    <div v-if="isAdmin || (getUserDetails.id === tool.createdBy)" class="alert alert-info p-1 mt-2 text-center">
                                        <div class="my-1">
                                            <router-link :to="{ name: 'EditTool', params: {id: tool.id }}"
                                                         class="btn btn-primary btn-sm text-white mb-0">
                                                <i class="fa fa-edit"></i> Uredi</router-link>

                                            <a class="btn btn-danger btn-sm text-white ml-1 mb-0"
                                               @click="deleteToolConfirmation(tool)"><i
                                                    class="fa fa-trash"></i> Odstrani</a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Product Single End -->


    </div>
</template>

<script>
    import firebase from 'firebase'
    import {db} from '../main'
    import {VueGoodTable} from 'vue-good-table'
    import 'vue-good-table/dist/vue-good-table.css'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'

    export default {
        name: 'Tool',
        components: {
            VueGoodTable,
            Loading
        },
        data() {
            return {
                id: this.$route.params.id,
                tool: {},
                isLoading: true,
                users: [],
                categories: [],
                contactPersons: [],
                isAdmin: JSON.parse(sessionStorage.getItem("HRAM_user")).administrator,
            }
        },
        firestore() {
            return {
                users: db.collection('users'),
                categories: db.collection('categories'),
                tool: db.collection('tools').doc(this.$route.params.id),
            }
        },
        mounted() {
            const _this = this;

            _this.isLoading= false;

        },
        computed: {
            getUserDetails() {
                return this.$store.getters.getUserDetails;
            },
            getPeople() {
                let people = [];

                _.map(this.users, function (item) {
                    _.each(item.people, function (innerItem) {
                        people.push(innerItem);
                    });
                });

                people = _.sortBy(people, function (item) {
                    return item.name;
                });

                return people;
            }
        },
        methods: {
            deleteToolConfirmation(data) {
                const _this = this

                this.$swal({
                    title: 'Opozorilo',
                    text: 'Ali ste prepričani, da želite izbrisati orodje ' + data.name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            text: 'Prekliči',
                            value: null,
                            visible: true,
                            className: '',
                            closeModal: true,
                        },
                        confirm: {
                            text: 'Izbriši',
                            value: true,
                            visible: true,
                            className: '',
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.deleteTool(data.id)

                            case null:

                                return

                                break

                            default:

                        }
                    })
            },
            deleteTool(id) {
                const _this = this
                _this.isLoading = true
                db.collection('tools').doc(id).delete()
                    .then(function () {
                        _this.isLoading = false
                        _this.$router.push('/orodja')
                    })
                    .catch(function (error) {
                        // The document probably doesn't exist.
                        console.error('Error deleting tool: ', error)
                    })
            },

            getReadableUser(userId) {
                const _this = this

                console.log("userId", userId);
                if (_this.users.length > 0 && userId &&  userId !== -1) {
                    let userObj = _.filter(_this.users, {'id': userId})[0] || _.filter(_this.users, {'id': userId.toLowerCase()})[0];
                    console.log(userObj);
                    console.log(_.filter(_this.users, {'id': userId})[0]);
                    console.log(_.filter(_this.users, {'id': userId.toLowerCase()})[0]);
                    if (userObj) {
                        return userObj.displayName
                    } else {
                        return userId
                    }
                } else {
                    return 'na drugi lokaciji'
                }
            },

            getReadableCategory(categoryId) {
                const _this = this

                console.log(categoryId)

                if (_this.categories.length > 0) {
                    let categoryObj = _.filter(_this.categories, {'id': categoryId})[0]
                    if(categoryObj) {
                        return categoryObj.name
                    }
                }
            },

            getReadableContactPerson(item) {
                const _this = this;

                let contactPerson = _.filter(_this.getPeople, {'name': item.contactPerson})[0];

                return contactPerson
            },

            onWhatsappClick(item) {
                const _this = this;
                let contactPerson = _this.getReadableContactPerson(item);
                //window.open("https://wa.me/" + "386" + contactPerson.phone.substr(1, contactPerson.phone.length) + "?text=" + encodeURIComponent("Živjo " + contactPerson.name.split(" ")[0] + ", španovija vprašanje :) Zanima me: " + item.name));

                let whatsappLink = "https://api.whatsapp.com/send?phone=" + "00386" + contactPerson.phone.substr(1, contactPerson.phone.length) + "&text=" + encodeURIComponent("Živjo " + contactPerson.name.split(" ")[0] + ", španovija vprašanje :) Zanima me: " + item.name);
                window.open(whatsappLink);
            },

            filterData(query) {
                const _this = this;
                _this.toolsToDisplay = _.filter(_this.tools, function (_item) {
                    return JSON.stringify(_item).toLowerCase().includes(query.toLowerCase());
                });
            },

            filterToCategory(categoryId) {
                const _this = this;

                _this.toolsToDisplay = _.filter(_this.tools, function (_item) {
                    return _item.category === categoryId;
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Tool.vue